import { useContext } from "react";
import { NewDashboardContext } from "./NewDashboardContextProvider";
var useNewDashboardContext = function useNewDashboardContext() {
  var context = useContext(NewDashboardContext);
  if (context === undefined) {
    throw new Error('useDashboardContext must be used within a DashboardContextProvider (included on NewDashboardRoot)');
  }
  return context;
};
export default useNewDashboardContext;